import { Link } from "react-router-dom";
import { sidebar_data } from "../Models/SidePanelModel";

export default function SidePanel({ handleHide, hide, active_page }) {
  return (
    <>
      <div
        id="bs-canvas-left"
        className={
          !hide
            ? "bs_open bs-canvas bs-canvas-anim bs-canvas-left position-fixed bg-light h-100"
            : "bs-canvas bs-canvas-anim bs-canvas-left position-fixed bg-light h-100"
        }>
        <header className="bs-canvas-header brand-se-web p-2 pt-3">
          <h4 className="d-inline-block text-light mb-0">
            <Link to="/">
              <img
                src="assets/img/logo-icon.png"
                className="img-icon"
                alt="Search Education"
              />
              <b>
                Search
                <br /> Education
              </b>
            </Link>
          </h4>
          <button
            type="button"
            className={
              hide ? "bs-canvas-close close" : "bs-canvas-close2 close"
            }
            onClick={handleHide}
            aria-label="Close">
            <span aria-hidden="true" className="text-light">
              &times;
            </span>
          </button>
        </header>
        <div className="bs-canvas-content nav-img-icon">
          <ul className="list-unstyled">
            {sidebar_data?.map((el, i) => (
              <li
                key={i}
                >
                <Link to={el.link ? el.link : "#"} title={el.name}>
                  <img src={el.logo} className="img-icon" alt={el.name} />
                  <span className="sed_show_menu">{el.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
